import React from 'react'
import styled from '@emotion/styled'
import AIEditableContainer from './AIEditableContainer'
import { HeaderLarge600Style } from '../../styles/Text.styles'
import theme from '../../styles/theme'
import { SetBodyFunction } from '../reports/types/ReportBodyTypes'
import {
  AITextType,
  type BaseSlice,
} from '../reports/comp_reusable/report_page_universal/stores/baseReportStore'

const TitleWrapper = styled.h3`
  ${HeaderLarge600Style};
  color: ${theme.colors.veryVeryFadedText};
  margin-bottom: 0.2rem;
`

// Type for a store that implements BaseSlice
type BaseStoreHook<T extends BaseSlice> = (selector: (state: T) => any) => any

// Props interface for AIEditableContainerWithTitle
interface AIEditableContainerWithTitleProps {
  title: string
  field?: string // Made optional since it's no longer used
  prompt: string
  textSrcType?: AITextType
  plotGroupId?: number
  plotPackageId?: number
  hasAIPlus?: boolean
  prevText?: string
  setReportDocument?: SetBodyFunction
  isNewlyGeneratedReport?: boolean
  store?: BaseStoreHook<any>
}

const AIEditableContainerWithTitle: React.FC<
  AIEditableContainerWithTitleProps
> = ({
  title,
  prompt,
  textSrcType,
  plotGroupId,
  plotPackageId,
  hasAIPlus,
  isNewlyGeneratedReport,
  store,
}) => {
  return (
    <div>
      <TitleWrapper>{title}</TitleWrapper>
      <AIEditableContainer
        isNewlyGeneratedReport={isNewlyGeneratedReport}
        title={title}
        prompt={prompt}
        textSrcType={textSrcType}
        plotGroupId={plotGroupId}
        plotPackageId={plotPackageId}
        hasAIPlus={hasAIPlus}
        maxHeight={400}
        store={store}
      />
    </div>
  )
}

export default AIEditableContainerWithTitle
